var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSadBoi = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 93,
    viewBox: "0 0 112 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93019 2.6651C2.32969 5.50524 -1.13212 10.9628 0.338913 14.6345C1.30377 17.0467 1.51139 16.9954 3.61888 13.8367C7.7117 7.70015 12.1207 4.54143 17.1798 4.12162C19.9142 3.89484 22.152 3.10246 22.152 2.36003C22.152 -0.013063 12.8182 0.188066 7.93019 2.6651ZM86.3087 1.06954C84.5065 2.89323 86.7266 4.38485 91.2429 4.38485C95.8677 4.38485 100.252 7.51927 104.466 13.8367C107.341 18.1482 109.581 14.2754 107.207 9.09457C104.532 3.25364 89.7569 -2.4199 86.3087 1.06954ZM7.79856 20.4795C-0.598799 28.8325 4.46703 42.7957 15.8946 42.7957C23.9555 42.7957 27.5801 38.7892 27.5801 29.8787C27.5801 17.5934 16.1566 12.1655 7.79856 20.4795ZM84.3125 19.791C79.1978 24.1673 78.792 35.0042 83.5647 39.7503C88.1678 44.3305 96.7307 43.9795 101.004 39.039C111.346 27.079 96.2028 9.61833 84.3125 19.791ZM42.6202 63.0817C35.7237 65.5263 30.2901 70.8624 31.5006 74.0008C32.3162 76.1148 32.7898 75.9946 36.1023 72.84C46.5081 62.9237 59.5207 62.755 69.9903 72.3985C73.5634 75.6896 74.7263 76.1337 76.0969 74.7325C82.8916 67.7874 55.873 58.3854 42.6202 63.0817ZM101.505 74.2411C100.776 76.2835 99.5696 79.0075 98.8246 80.2967C94.573 87.6414 101.144 95.8959 108.141 92.0015C112.854 89.38 113.182 85.8474 109.498 77.4538C106.109 69.7325 103.489 68.6796 101.505 74.2411Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8246 80.2967C99.5696 79.0075 100.776 76.2835 101.505 74.2411C103.489 68.6796 106.109 69.7325 109.498 77.4538C113.182 85.8474 112.854 89.38 108.141 92.0015C101.144 95.8959 94.573 87.6414 98.8246 80.2967Z",
    fill: "#3C82DA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSadBoi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sad-boi.12cf3c444d5e7da0471ef5a7232cd0c6.svg";